export default __webpack_public_path__ + "static/media/homepage-image2.968b0cd7.png";